import React, {useContext, useState} from 'react';
import TemplateDefault from "../../components/template-default";
import {Accordion, AccordionItem} from "@szhsin/react-accordion";
import Card from "../../components/card";
import "./components/accordion.css"
import Button from "../../components/button";
import general from "../../utils/general";
import {useQuery} from "@tanstack/react-query";
import versionsService from "../../services/versions-service";
import {useNavigate} from "react-router-dom";
import {FaPlusSquare} from "react-icons/fa";
import {ProjectContext} from "../../context/project-context";

const Version = () => {
    const navigate = useNavigate();
    const [versions, setVersions] = useState([])
    const {user} = useContext(ProjectContext);
    const canEditVersions = user.permissions.includes("edit_versions");

    const {isFetching} = useQuery({
        queryFn: () => versionsService.list().then(({data}) => {
            data.forEach(version => {
                return version.attachs = JSON.parse(version.attachs);
            })
            setVersions(data)
            return[]
        }),
        queryKey: ['version'],
    });


    return (
        <TemplateDefault title={"Versões"} isLoading={isFetching}>
            <Card>
                <div className="flex justify-between w-full m-3">
                    <h1>Histórico de versões</h1>

                    {
                        canEditVersions &&
                            <Button col="col-span-2" onClick={() => navigate("/versions/form")}>
                                <FaPlusSquare /> Nova versão
                            </Button>
                    }
                </div>

                {versions.map((item, index) => (
                    <div className={"accordion" + index} key={index}>
                        <Accordion>
                            <AccordionItem header={
                                <>
                                    <div className={"flex justify-between w-full"}>
                                        <div className={"flex justify-between"} style={{width: "15%"}}>
                                            <p>{item.version}</p>
                                        </div>
                                        <p>{general.formatDate(item.date, "DD/MM/YYYY")}</p>
                                    </div>

                                </>
                            }>
                                <Card wrapperClass={"accordion-bg"}>
                                    <div className={"flex justify-between w-full"}>
                                        <div className={"flex justify-between"} style={{width: "40%"}}>
                                            <p>ID: {item.id}</p>
                                            <p>Versão: {item.version}</p>
                                            <p>Data: {general.formatDate(item.date, "DD/MM/YYYY")}</p>
                                            <p>Anexos: {item.attachs?.length}</p>
                                        </div>
                                        {
                                            canEditVersions &&
                                                <Button onClick={() => navigate(`/versions/form/${item.id}`)} target="primary">
                                                    Editar
                                                </Button>
                                        }
                                    </div>

                                    <div>
                                        <p>Conteudo:</p>
                                        <div className={"p-2 editor-disabled"}>
                                            <div
                                                className="formatted-content"
                                                dangerouslySetInnerHTML={{ __html: item.content }}
                                            />
                                        </div>
                                    </div>
                                </Card>
                            </AccordionItem>
                        </Accordion>

                    </div>
                ))}

            </Card>
        </TemplateDefault>
    );
};

export default Version;
